<template>
  <el-dialog
    title="审核"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form size="small" :model="form" ref="form">
      <el-form-item
        label="是否同意"
        :label-width="formLabelWidth"
        prop="status"
        :rules="[{ required: true, message: ' ' }]"
      >
        <el-switch
          :active-value="1"
          :inactive-value="0"
          v-model="form1.status"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item
        label="审核意见"
        :label-width="formLabelWidth"
        prop="remark"
      >
        <el-input v-model="form1.remark" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submit" :disabled="submit_loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import UserApi from "@/api/user.js";
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: "180px",
      /*是否显示*/
      dialogVisible: false,
      /*是否正在提交*/
      submit_loading: false,
      isproduct: false,
      type: 10,
      num: 20,
      tableData: [],
      product_arr: [],
      form1: {
        status: 1,
        remark: "",
        id: ""
      }
    };
  },
  props: ["open_edit", "form"],
  created() {
    this.form.open_money = this.form.open_money == 1 ? true : false;
    this.form.open_points = this.form.open_points == 1 ? true : false;
    this.form.open_invite = this.form.open_invite == 1 ? true : false;
    // yong
    this.form1.id = this.form.id;
    this.dialogVisible = this.open_edit;
  },
  methods: {
    submit() {
      let self = this;
      self.submit_loading = false;
      self.$message({
        message: "恭喜你，审核成功",
        type: "success"
      });
      self.dialogFormVisible(true);
    },

    /*修改用户*/
    editGrade() {
      let self = this;
      let params = this.form1;

      params.level = this.form.level;
      params.product = self.tableData;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.submit_loading = true;
          params.open_money = params.open_money == true ? 1 : 0;
          params.open_points = params.open_points == true ? 1 : 0;
          params.open_invite = params.open_invite == true ? 1 : 0;
          self.dialogFormVisible(true);
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/citymanager/finance/transfer/review.vue